module.exports = __webpack_public_path__ + "static/media/luaLogo.976d2d73.svg";